module.exports = __webpack_public_path__ + "img/HeadQ_preview.59138b11.png";